import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import actions from 'actions/products'
import Component from 'components/Orders/AddItems/SearchProducts/Filter'

const mapStateToProps = (state, props) => ({ ...createAuthStateToProps(state, props) })

export default connect(mapStateToProps, { getProductCatalogs: actions.getCatalogs })(Component)
